/**
 * @file       Filters module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import moment from "moment";

// Moment date format to fr-ca, format: "lll"
Vue.filter("formatDateTime", function(value) {
  moment.locale("fr-ca");
  if (value) {
    return moment(String(value)).format("lll");
  }
});

// Moment date format to fr-ca, format: "MMM Do YY"
Vue.filter("formatDate", function(value) {
  moment.locale("fr-ca");

  if (value) {
    return moment(String(value)).format("MMM Do YY");
  }
});

// Convert string to upper case on non-null and non-empty strings
Vue.filter("toUpperCase", function(value) {
  if (value) {
    return value.toUpperCase();
  }
});

// Remove decimals or return "--" if not a number
Vue.filter("removeDecimals", function(value) {
  if (value && parseInt(value) && parseInt(value) != 0) {
    return Math.round(value);
  } else {
    return "--";
  }
});
